import { render, staticRenderFns } from "./GalleryList.vue?vue&type=template&id=d0c1c128&scoped=true&"
import script from "./GalleryList.vue?vue&type=script&lang=js&"
export * from "./GalleryList.vue?vue&type=script&lang=js&"
import style0 from "./GalleryList.vue?vue&type=style&index=0&id=d0c1c128&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c1c128",
  null
  
)

export default component.exports